module.exports = __webpack_public_path__ + "img/q3-roll-01.eaeff474.svg";